import {
  ExpensesCustomizationConfigResourceTypeEnum,
  ExpensesValueObjectsCustomizationDocumentTypeEnum,
} from 'generated/resources/graphql'
import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'

import { hasAnyEnabledField as hasAnyEnabledFieldHelper } from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import { CustomizationField, isMandatory } from 'modules/expenses/hooks/useExpensesCustomization'

const defaultRequiredMessage = () => ({
  message: i18n.t('expenses_v2.forms.errors.required'),
})

export interface FormContext {
  customizationFields: CustomizationField[]
  resourceType: ExpensesCustomizationConfigResourceTypeEnum
}

export const AdditionalInformationSchema = ({ customizationFields, resourceType }: FormContext) => {
  return z.object({
    internalReference: z
      .string()
      .optional()
      .nullable()
      .refine(
        (internalReference) =>
          isMandatory('internal_reference', resourceType, customizationFields)
            ? !!internalReference
            : true,
        defaultRequiredMessage()
      ),
    description: z
      .string()
      .optional()
      .nullable()
      .refine(
        (description) =>
          isMandatory('description', resourceType, customizationFields) ? !!description : true,
        defaultRequiredMessage()
      ),
  })
}

export const shouldShowBlock = (
  customizationFields: CustomizationField[],
  resourceType: ExpensesCustomizationConfigResourceTypeEnum,
  documentType: ExpensesValueObjectsCustomizationDocumentTypeEnum
): boolean => {
  return hasAnyEnabledFieldHelper(
    ['internal_reference', 'description'],
    resourceType,
    customizationFields,
    documentType
  )
}

export type AdditionalInformationSchema = z.infer<ReturnType<typeof AdditionalInformationSchema>>
